import React, { Component } from 'react';
import { Example } from 'examples';
import Group from '../../src/components/Group/Group';
import RadioButton from '../../src/components/RadioButton/RadioButton';

const RESOLUTION = [320, 480, 600, 768, 1024, 1200, 1600];

const LABELS = [
  'Application title',
  'Lightbox title',
  'Group title',
  'Group title 2',
  'Body',
  'Button',
  'Label',
];

const STYLES = {
  320: [
    { text: 'ROBOTO CONDENSED, Bold 700, 1.125 rem, UPPERCASE', style: { fontFamily: 'Roboto Condensed', fontWeight: 700, fontSize: '1.125rem' } },
    { text: 'Roboto Condensed, Light 300, 1.375 rem', style: { fontFamily: 'Roboto Condensed', fontWeight: 300, fontSize: '1.375rem' } },
    { text: 'Roboto Condensed, Light 300, 1.125 rem' },
    { text: 'Roboto Condensed, Light 300, 1.125 rem' },
    { text: 'Roboto, Regular 400, 0.875 rem', style: { fontWeight: 400, fontSize: '0.875rem' } },
    { text: 'Roboto, Bold 700, 0.875 rem', style: { fontWeight: 700, fontSize: '0.875rem' } },
    { text: 'ROBOTO, BOLD 700, 0.75 rem, UPPERCASE', style: { fontWeight: 700, fontSize: '0.75rem', color: '#9b9b9b' } },
  ],
  480: [
  ],
  600: [
  ],
  768: [
  ],
  1024: [
  ],
  1200: [
  ],
  1600: [
    null,
    { text: 'Roboto Condensed, Light 300, 2 rem', style: { fontWeight: 300, fontSize: '2rem' } },
    { text: 'Roboto Condensed, Light 300, 1.5 rem', style: { fontWeight: 300, fontSize: '1.5rem' } },
    { text: 'Roboto Condensed, Light 300, 1.25 rem', style: { fontWeight: 300, fontSize: '1.25rem' } },
  ],
};

export default class Typography extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resolution: 1600,
    };
  }

  onChange = e => {
    this.setState({
      resolution: parseInt(e.target.dataset.index, 10),
    });
  };

  getValues = (resolution = 320, index = 0) => {
    let pos = RESOLUTION.indexOf(resolution);

    while (pos >= 0) {
      if (STYLES[RESOLUTION[pos]][index]) {
        return STYLES[RESOLUTION[pos]][index];
      }
      --pos;
    }
    return 'not defined';
  };

  getStyles = (resolution) =>
    LABELS.map((label, index) => {
      const config = this.getValues(resolution, index);

      return (
        <tr key={index}>
          <th>{label}</th>
          <td style={config.style}>{config.text}</td>
        </tr>
      );
    });

  render() {
    return (
      <Example title="Typography" className="no-props no-code-example">
        <Group>
          <div className="typeface condensed">
            <h3>Roboto Condensed</h3>
            <ul>
              <li className="light">Light 300</li>
              <li className="bold">Bold 700</li>
            </ul>
          </div>
          <div className="typeface">
            <h3>Roboto</h3>
            <ul>
              <li className="regular">Regular 400</li>
              <li className="medium">Medium 500</li>
              <li className="bold">Bold 700</li>
            </ul>
          </div>
        </Group>
        <hr/>
        <Group title="Styles" className="styles">
          <div>
            <p>
              Too many type sizes and styles at once can wreck any layout. A typographic scale has a limited set of type sizes that
              work well together along with the layout grid. These sizes and styles were developed to balance content density and
              reading comfort under typical usage conditions. Type sizes are specified in REM to enable large type modes for
              accessibility.
            </p>
            <table>
              <tbody>
              {this.getStyles(this.state.resolution)}
              </tbody>
            </table>
          </div>
          <div className="resolution">
            <h3>Resolution</h3>
            {RESOLUTION.map(resolution => <RadioButton key={resolution} label={resolution.toString()} checked={resolution === this.state.resolution} data-index={resolution} onChange={this.onChange}/>)}
          </div>
        </Group>
      </Example>
    );
  }

}
